import React from 'react';
import config from "../../../config/index";
import styles from './numberTransferTypes.module.scss'

const NumberTransferOption = ({
    icon,
    title,
    onClick,
    selected
}) => {
    const env = config.env;
	const imagePrefix = config.envConfigs[env].imagePrefix;
    return (
        <button className={`${styles["number-transfer-types__option"]} ${selected && styles["number-transfer-types__option__selected"]}`} onClick={onClick}>
            <img src={`${imagePrefix}/assets/images/${icon}.svg`} />
            <div className={styles["number-transfer-types__option__title"]}>{title}</div>
        </button>
    );
};

export default NumberTransferOption;